var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n"], ["\n  align-items: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ",
    ";\n"])), function (props) { return (props.inline ? 'center' : 'normal'); }, function (props) { return (props.inline ? 'row' : 'column'); }, function (props) {
    return props.inline && props.spaceBetween ? 'space-between' : '';
});
var templateObject_1;
//# sourceMappingURL=Label.js.map